// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"d6030026","787":"4e626067"}[chunkId] + ".chunk.js";
};